export default "__VITE_ASSET__BU8CUbht__"